/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PanIcon = ({ width = 24, height = 24, hidden = false, title = 'Pan' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M31.647 9.806c-.938-.335-1.971.5-2.406 1.524l-2.7 4.846c-.2.461-.7.889-1.062.708s-.46-.668-.278-1.45l1.3-8.858a2.278 2.278 0 0 0-1.714-2.871 2.1 2.1 0 0 0-2.116 1.8l-1.236 8.258s-.09 1.073-.826 1.036-.657-1.134-.657-1.134v-9.66a2.145 2.145 0 0 0-1.968-2.286 2.145 2.145 0 0 0-1.969 2.286v9.62c0 .6-.791.589-.938.093-.677-2.294-2.166-7.483-2.166-7.483A2.053 2.053 0 0 0 10.7 4.6a2.324 2.324 0 0 0-1.554 2.991l2.682 9.057a8.658 8.658 0 0 1 .247 1.229 2.08 2.08 0 0 1-.739 2.1c-.383.254-5.315-2.882-5.315-2.882-1.968-1.555-3.182-1.017-3.691-.317-.542.745-.164 1.968.617 2.91l6.969 6.993a4.155 4.155 0 0 1 .43.7 26.63 26.63 0 0 0 2.054 3.672c1.378 1.752 3.331 2.666 6.234 2.666 3.664 0 6.382-1.626 7.35-4.266.656-2.21 1.277-5.192 1.575-6.23.194-.678 4.965-10.393 4.965-10.393.533-1.242.317-2.597-.877-3.024Z"
    />
  </svg>`;
};
